"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageAbsorbEffectHandler = exports.DamageAbsorbEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class DamageAbsorbEffectArgs {
    constructor(damages, totalAbsorb = Object.values(damages)
        .reduce((sum, next) => sum + next, 0)) {
        this.damages = damages;
        this.totalAbsorb = totalAbsorb;
        this.__type = EffectType_1.EffectType.DamageAbsorb;
        this.__typeName = "DamageAbsorb";
        this.name = "Damage Absorb";
        this.harmful = false;
    }
}
exports.DamageAbsorbEffectArgs = DamageAbsorbEffectArgs;
let DamageAbsorbEffectHandler = class DamageAbsorbEffectHandler {
    apply(sequence, container, state) {
        state.meta.remainingAbsorb = state.args.totalAbsorb;
        state.meta.absorbsByDamageType = state.args.damages;
    }
    remove(sequence, container, state) {
    }
};
DamageAbsorbEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.DamageAbsorb)
], DamageAbsorbEffectHandler);
exports.DamageAbsorbEffectHandler = DamageAbsorbEffectHandler;
